var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShiledPc = function SvgShiledPc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 54"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ShiledPc_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#fff",
    fillOpacity: 0,
    rx: 2
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ShiledPc_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M12 12h30v30H12z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#402C22",
    rx: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ShiledPc_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23.98 38.01c-.7-.15-1.41-.38-2.14-.67.25-2.52.98-4.88 2.19-7.06 1.2-2.19 2.76-4.12 4.65-5.78-2.29 1.16-4.27 2.7-5.95 4.62s-2.85 4.1-3.52 6.56c-.08-.06-.16-.13-.23-.2l-.23-.23a10.3 10.3 0 0 1-2.24-3.29c-.51-1.2-.76-2.46-.76-3.78 0-1.41.28-2.77.84-4.06s1.34-2.44 2.34-3.44c1.69-1.68 3.88-2.78 6.57-3.29 2.68-.51 6.45-.56 11.31-.14.37 4.97.31 8.77-.19 11.39-.5 2.61-1.58 4.75-3.25 6.42-1.02 1.02-2.16 1.81-3.42 2.36s-2.56.83-3.89.83c-.69 0-1.38-.08-2.08-.24Z"
  }))));
};
export default SvgShiledPc;